import { View, Text } from "react-native";
import ScButton from "../../ui-kit/button";
import { CustomColor } from "./appearance";
import { derivePalette } from "../../../utils/derive-palette";

type CustomColorRowProps = Readonly<{
  item: CustomColor;
  onEdit: () => void; // parent owns which item is being edited
}>;

const SWATCHES = [
  { label: "Default", key: "default" },
  { label: "Light", key: "1" },
  { label: "Wash", key: "2" },
] as const;

const CustomColorRow = ({ item, onEdit }: CustomColorRowProps) => {
  const palette = derivePalette(item.hex);

  return (
    <View className="p-4 rounded-xl border border-ash-3 bg-chalk w-full md:w-72 gap-3">
      {/* Header row */}
      <View className="flex-row items-center justify-between">
        <View className="gap-0.5">
          <Text className="text-xs font-medium text-onyx">{item.label}</Text>
          <Text className="text-xs text-ash-1">{item.hex.toUpperCase()}</Text>
        </View>
        <ScButton mode="outlined" text="BTN_EDIT" onPress={onEdit} />
      </View>

      {/* Palette preview */}
      <View className="flex-row gap-2">
        {SWATCHES.map(({ label, key }) => (
          <View key={label} className="items-center gap-1">
            <View
              className="w-8 h-8 rounded-lg border border-ash-3"
              style={{ backgroundColor: palette[key] }}
            />
            <Text className="text-xs text-ash-1">{label}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default CustomColorRow;
